module.exports = __webpack_public_path__ + "static/img/img-about-move-mais-2026.47eecfc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/img-about-move-mais-2026.svg
// module id = 1776
// module chunks = 1